import CryptoJS from "crypto-js";


// Encrypt function
export function encryptData(obj) {
    const stringified = JSON.stringify(obj);
    const encrypted = CryptoJS.AES.encrypt(stringified, process.env.REACT_APP_SECRET_KEY).toString();
    return encrypted;
}
  
// Decrypt function
export function decryptData(ciphertext, key = null) {
    if (ciphertext == null) {
        return null;
    }
    const bytes = CryptoJS.AES.decrypt(ciphertext, key !== null ? key : process.env.REACT_APP_SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
}

export function decryptDatas(encryptedBase64) {
    // If URL encoded, decode it first
    const encryptedData = decodeURIComponent(encryptedBase64);

    // Convert Base64 string to WordArray
    const encryptedWordArray = CryptoJS.enc.Base64.parse(encryptedData);

    // Convert WordArray to Byte Array
    const encryptedBytes = encryptedWordArray.words;

    // Convert to OpenSSL format
    const salt = CryptoJS.lib.WordArray.create(encryptedWordArray.words.slice(2, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(encryptedWordArray.words.slice(4), encryptedWordArray.sigBytes - 16);

    // Derive key and IV using OpenSSL key derivation
    const keySize = 256 / 32;
    const ivSize = 128 / 32;
    const iterations = 1;

    const keyIv = CryptoJS.EvpKDF(process.env.REACT_APP_SECRET_KEY, salt, {
    keySize: keySize + ivSize,
    iterations: iterations,
    hasher: CryptoJS.algo.MD5
    });

    const key = CryptoJS.lib.WordArray.create(keyIv.words.slice(0, keySize));
    const iv = CryptoJS.lib.WordArray.create(keyIv.words.slice(keySize, keySize + ivSize));

    // Decrypt
    const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: ciphertext },
    key,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    // Convert decrypted WordArray to UTF-8 string
    const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
    return plaintext;
}

export function generateHex32() {
    return [...Array(32)]
      .map(() => Math.floor(Math.random() * 16).toString(16))
      .join('');
}